<template>
  <div class="hold-transition">
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Equipos</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/Admin">Administrativo</router-link>
                  </li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Equipos</li>
                </ol>
              </div>
            </div>
          </div>
          <!-- /.container-fluid -->
        </section>
        <!-- Main content -->
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-12">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn btn-info"
                        @click="pivotTable()"
                        v-if="$store.getters.can('admin.equipos.pivotTable')"
                      >
                        <i class="fas fa-scroll"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        data-target="#modal_form_equipo_export"
                        v-if="$store.getters.can('admin.equipos.export')"
                      >
                        <i class="far fa-file-excel"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        v-if="$store.getters.can('admin.equipos.create')"
                        @click="create()"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body p-0">
                <table
                  id="users"
                  class="
                    table table-bordered table-striped table-hover table-sm
                  "
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th>
                        Placa
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.placa"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Serial
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.serial"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>Peso</th>
                      <th>Marca</th>
                      <th>
                        Empresa
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="listasForms.selct_empresa"
                          placeholder="Empresas"
                          label="razon_social"
                          class="form-control form-control-sm p-0"
                          :options="empresas"
                          @search="buscarEmpresas"
                          @input="getIndex()"
                        ></v-select>
                      </th>
                      <th>Tipo de equipo</th>
                      <th>Propiedad</th>
                      <th>Combustible</th>
                      <th>Modelo</th>
                      <th>
                        Líneas Negocio
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="linea_negocio"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.lineas_negocio"
                          :filterable="true"
                          multiple
                          @input="getIndex()"
                        ></v-select>
                      </th>
                      <th>Estado Documental</th>
                      <th>
                        Estado
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="equipo in equipos.data" :key="equipo.id">
                      <td>
                        <a
                          :href="uri_docs + equipo.link_fotografia"
                          target="_blank"
                        >
                          <img
                            :src="uri_docs + equipo.link_fotografia"
                            alt="Equipo"
                            width="75"
                            class="rounded mx-auto d-block"
                          />
                        </a>
                      </td>
                      <td>{{ equipo.placa }}</td>
                      <td>{{ equipo.serial }}</td>
                      <td>{{ equipo.peso }}</td>
                      <td>{{ equipo.Marca }}</td>
                      <td>
                        {{
                          equipo.empresa != null
                            ? equipo.empresa.razon_social
                            : "No encontrada"
                        }}
                      </td>
                      <td>{{ equipo.TipoEquipo }}</td>
                      <td>{{ equipo.TipoPropiedad }}</td>
                      <td>{{ equipo.TipoCombustible }}</td>
                      <td>{{ equipo.modelo }}</td>
                      <td class="text-center">
                        <div
                          v-for="lineas in equipo.lineas_negocio"
                          :key="lineas.id"
                        >
                          <span class="badge bg-navy">
                            {{ lineas.nombre }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="row">
                          <div class="col-md-6">
                            <span
                              v-if="equipo.documentos_vencidos.length > 0"
                              class="badge badge-danger"
                            >
                              Documentos vencidos ({{
                                equipo.documentos_vencidos.length
                              }})
                            </span>
                            <span
                              v-if="equipo.paquetes.length <= 0"
                              class="badge badge-danger"
                            >
                              Sin paquete Documental
                            </span>
                            <span
                              v-if="equipo.documentos_pendientes.length > 0"
                              class="badge badge-warning"
                            >
                              Documentos pendientes ({{
                                equipo.documentos_pendientes.length
                              }})
                            </span>

                            <span
                              v-if="
                                equipo.documentos_no_verificados.length > 0
                              "
                              class="badge badge-info"
                            >
                              Documentos no verificados ({{
                                equipo.documentos_no_verificados.length
                              }})
                            </span>

                            <span
                              v-if="
                                equipo.documentos_vencidos.length === 0 &&
                                  equipo.documentos_pendientes.length === 0 &&
                                  equipo.documentos_no_verificados.length ===
                                  0 && equipo.paquetes.length > 0
                              "
                              class="badge badge-success"
                            >
                              Verificado
                            </span>
                          </div>
                        </div>
                      </td>
                      <td style="width: 85px" align="right">
                        <div class="row">
                          <div class="col-md-6">
                            <span
                              class="badge"
                              data-toggle="modal"
                              data-target="#modal-form-estado"
                              style="cursor: pointer"
                              v-if="
                                $store.getters.can('admin.equipos.editStatus')
                              "
                              v-bind:class="[
                                equipo.estado == 1
                                  ? 'badge-success'
                                  : 'badge-danger',
                              ]"
                              @click="llenarModal(equipo.id, equipo.estado)"
                            >
                              {{ equipo.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                            </span>
                          </div>
                          <div class="col-md-6">
                            <i
                              class="fas fa-eye"
                              data-toggle="modal"
                              data-target="#modal-historial-estado"
                              style="cursor: pointer"
                              v-if="$store.getters.can('admin.equipos.show')"
                              @click="
                                llenarModalHistorial('App\\Equipo', equipo.id)
                              "
                            ></i>
                          </div>
                        </div>
                      </td>
                      <td style="width: 50px">
                        <div class="btn-group float-right">
                          <button
                            type="button"
                            class="btn btn-sm bg-secondary"
                            v-if="$store.getters.can('admin.equipos.show')"
                            @click="edit(equipo, 1)"
                          >
                            <i class="fas fa-eye"></i>
                          </button>
                          <div v-if="empresa.length > 0">
                            <div v-if="equipo.tipo_propiedad == 1">
                              <div v-if="equipo.empresa_id">
                                <div>
                                  <button
                                    type="button"
                                    class="btn btn-sm bg-navy"
                                    v-if="
                                      $store.getters.can(
                                        'admin.equipos.edit'
                                      ) && empresa[0].id == equipo.empresa_id
                                    "
                                    @click="edit(equipo, 2)"
                                  >
                                    <i class="fas fa-edit"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <button
                                type="button"
                                class="btn btn-sm bg-navy"
                                v-if="$store.getters.can('admin.equipos.edit')"
                                @click="edit(equipo, 2)"
                              >
                                <i class="fas fa-edit"></i>
                              </button>
                            </div>
                          </div>
                          <div v-else>
                            <button
                              type="button"
                              class="btn btn-sm bg-navy"
                              v-if="$store.getters.can('admin.equipos.edit')"
                              @click="edit(equipo, 2)"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="equipos.total">
                  <p>
                    Mostrando del <b>{{ equipos.from }}</b> al
                    <b>{{ equipos.to }}</b> de un total:
                    <b>{{ equipos.total }}</b> Registros
                  </p>
                </div>
                <div class="float-left" v-else>
                  <p>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </p>
                </div>
                <pagination
                  :data="equipos"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  align="right"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
        <EquipoEstado ref="EquipoEstado" />
        <HistorialEstado ref="HistorialEstado" />
      </div>
    </div>
    <EquipoExport ref="EquipoExport" />
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import EquipoEstado from "./EquipoEstado";
import HistorialEstado from "../historialEstado/HistorialEstado";
import EquipoExport from "./EquipoExport";
import vSelect from "vue-select";

export default {
  name: "EquipoIndex",
  components: {
    pagination,
    EquipoEstado,
    EquipoExport,
    HistorialEstado,
    vSelect,
  },
  data() {
    return {
      linea_negocio: [],
      empresas: [],
      empresa: this.$store.getters.getUser.empresas,
      filtros: {
        placa: null,
        serial: null,
        empresa: null,
        empresa_id: null,
        estado: null,
      },
      equipos: {},
      listasForms: {
        empresas: [],
        tiposCarrocerias: [],
        estados: [],
        lineas_negocio: [],
        selct_empresa: [],
      },
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  validations: {},
  methods: {
    getIndex(page = 1) {
      this.filtros.lineas_negocio = [];
      this.filtros.empresa_id = null;
      this.linea_negocio.forEach((linea) => {
        this.filtros.lineas_negocio.push(linea.id);
      });
      if (this.listasForms.selct_empresa) {
        this.filtros.empresa_id = this.listasForms.selct_empresa.id;
      }
      axios
        .get("/api/admin/equipos?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.equipos = response.data;
        });
    },

    getLineasNegocio() {
      axios.get("/api/admin/lineasNegocios/lista").then((response) => {
        this.listasForms.lineas_negocio = response.data;
      });
    },

    getEmpresas() {
      axios.get("/api/admin/empresas/lista").then((response) => {
        this.listasForms.empresas = response.data;
      });
    },

    getTiposCarrocerias() {
      axios.get("/api/lista/9").then((response) => {
        this.listasForms.tiposCarrocerias = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/empresas/lista?razon=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.empresas = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    destroy(idEquipo) {
      this.$swal({
        title: "Esta seguro de eliminar este Item?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios.delete("/api/admin/equipos/" + idEquipo).then((response) => {
            this.getIndex();
            this.$swal({
              icon: "success",
              title: "Se elimino el vehículo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
        }
      });
    },

    create() {
      return this.$router.push({
        name: "/Admin/EquipoForm",
        params: { accion: "Crear", id: 0 },
      });
    },

    edit(equipo, opcion) {
      return this.$router.push({
        name: "/Admin/EquipoForm",
        params: {
          accion: "Editar",
          data_edit: equipo,
          id: equipo.id,
          opcion: opcion,
        },
      });
    },

    pivotTable() {
      return this.$router.push({
        name: "/Admin/EquipoPivotTable",
      });
    },
    llenarModal(id, estado) {
      if (this.$store.getters.can("admin.equipos.show")) {
        this.$refs.EquipoEstado.llenar_modal(id, estado);
      }
    },

    llenarModalHistorial(entidad, entidad_id) {
      if (this.$store.getters.can("admin.equipos.show")) {
        this.$refs.HistorialEstado.llenar_modal(entidad, entidad_id);
      }
    },
    generarListadoExcel() {
      this.$parent.cargando = true;

      axios({
        method: "POST",
        url: "/api/admin/equipos/export",
        data: this.form,
      })
        .then((response) => {
          let data = response.data;
          this.$parent.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },
  },
  mounted() {
    this.getIndex();
    this.getEmpresas();
    this.getTiposCarrocerias();
    this.getEstados();
    this.getLineasNegocio();
  },
};
</script>
